import { render, staticRenderFns } from "./EditionModal.vue?vue&type=template&id=c639511a&scoped=true"
import script from "./EditionModal.vue?vue&type=script&lang=js"
export * from "./EditionModal.vue?vue&type=script&lang=js"
import style0 from "./EditionModal.vue?vue&type=style&index=0&id=c639511a&prod&scoped=true&lang=scss"
import style1 from "./EditionModal.vue?vue&type=style&index=1&id=c639511a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c639511a",
  null
  
)

export default component.exports